const messageType = {
  IMAGE_TYPE: 'application/x-image',
  IMAGE_MAP_TYPE: 'application/x-imagemap',
  AUDIO_TYPE: 'application/x-audio',
  VIDEO_TYPE: 'application/x-video',
  FILE_TYPE: 'application/x-file',
  LOCATION_TYPE: 'application/x-location',
  TEMPLATE_TYPE: 'application/x-template',
  LINE_STICKER_TYPE: 'application/x-line-sticker',
  TEXT_PLAIN_TYPE: 'text/plain',
  SHARE_TYPE: 'application/x-share',
  FORM_TYPE: 'application/x-form',
  NOTIFY_EVENT: 'application/x-notify-event',
  STORY_MENTION: 'application/x-story_mention',
  LIKE_HEART: 'application/x-like-heart',
  DELETE: 'application/x-delete',
  CUSTOMER_SHARE: 'application/x-customer-share',
  UNSUPPORTED: 'application/x-unsupported',
};

export default messageType;
